import {
  SET_INTEGRATIONS,
  START_LOAD_INTEGRATIONS,
  END_LOAD_INTEGRATIONS,
  SET_SALESFORCE_RECORS,
  LOAD_SALESFORCE_BY_RESOURCE_TYPE,
  RESET_INTEGRATIONS_STATE,
  REMOVE_SALESFORCE_INTEGRATION
} from '@/state/mutationTypes'

import getIntegrationsStoreDefaultState from '@/state/integrationStore/integrationStoreDefaultState'

export default {
  [START_LOAD_INTEGRATIONS](state) {
    state.integrationListLoading = true
    state.integrationListLoaded = false
  },
  [END_LOAD_INTEGRATIONS](state) {
    state.integrationListLoading = false
    state.integrationListLoaded = true
  },
  [SET_INTEGRATIONS](state, integrations) {
    state.integrations = integrations
  },
  [SET_SALESFORCE_RECORS](state, payload) {
    state.salesForceRecords = payload
  },
  [LOAD_SALESFORCE_BY_RESOURCE_TYPE](state, payload) {
    state.loadingSalesforceByResourceType = payload
  },
  [REMOVE_SALESFORCE_INTEGRATION](state, payload) {
    let { integrations } = state
    const integrationIndex = integrations.findIndex(
      integration => parseInt(integration.id) != parseInt(payload)
    )
    integrations.splice(integrationIndex, 1)
    state.integration = [...integrations]
  },
  [RESET_INTEGRATIONS_STATE](state) {
    Object.assign(state, getIntegrationsStoreDefaultState())
  }
}
